// @flow

import React from "react";
import { compose } from "redux";
import { connect } from "react-redux";
import { localize } from "redux-i18n";

import actionCreators from "@modules/service/actionCreator";
import * as serviceSelectors from "@modules/service/selectors";
import * as sharedSelectors from "@modules/shared/selectors";
import { Button } from "@components";
import type {
  DynamicQuestionContent,
  AbsenceReason,
} from "@modules/service/reducer/dynamic-questions/types";
import type { StepProps } from "@components";
import { ReasonSpecificUsageForm } from "../dynamic-question-reason-specific-usage";
import { split } from "@transformers/schema";

type PropsFromState = $Exact<{
  draft: ?DynamicQuestionContent,
  absenceReasons: Array<AbsenceReason>,
  schema: ?Object,
}>;

type PropsFromDispatch = $Exact<{
  onUpdateDraft: typeof actionCreators.UpdateDynamicQuestionDraft,
}>;

type Props = $Exact<{
  ...StepProps,
  ...PropsFromLocalize,
  ...PropsFromState,
  ...PropsFromDispatch,
}>;

export class Step3ReasonSpecificUsages extends React.Component<Props> {
  absenceReasonsSchema = split(this.props.schema, ["absenceReasons"]);
  reasonSpecificUsageFormRef: *;

  handleReasonSpecificUsageRef = (ref: *) => {
    this.reasonSpecificUsageFormRef = ref;
  };

  handleReasonSpecificUsageNext = () => {
    this.reasonSpecificUsageFormRef.submit();
  };

  handleChange = (data: Array<AbsenceReason>) => {
    if (data) {
      this.props.onUpdateDraft({ ...this.props.draft, absenceReasons: data });
    }
  };

  handleSubmittedReasonSpecificUsageForm = (data: Array<AbsenceReason>) => {
    if (data) {
      const updatedDraft = { ...this.props.draft, absenceReasons: data };
      this.props.onUpdateDraft(updatedDraft);
      if (this.props.handleSubmit) {
        this.props.handleSubmit(updatedDraft, true);
      }
    }
  };

  get data(): ?Array<AbsenceReason> {
    return this.props.draft ? this.props.draft.absenceReasons : null;
  }

  render() {
    if (!this.props.editable) {
      return null;
    }

    return (
      <React.Fragment>
        <div className="w-100 d-flex justify-content-center">
          <div className="col-sm-12">
            <ReasonSpecificUsageForm
              onRef={this.handleReasonSpecificUsageRef}
              data={this.data}
              schema={this.absenceReasonsSchema}
              reasons={this.props.absenceReasons}
              onSubmit={this.handleSubmittedReasonSpecificUsageForm}
              onChange={this.handleChange}
            />
          </div>
        </div>
        <div className="w-100 d-flex justify-content-end mt-5 mb-3">
          <Button materialIcon="fast_forward" onClick={this.handleReasonSpecificUsageNext}>
            {this.props.t("NEXT")}
          </Button>
        </div>
      </React.Fragment>
    );
  }
}

const mapStateToProps = (state, ownProps): PropsFromState => {
  return {
    draft: serviceSelectors.getDynamicQuestionDraft(state),
    absenceReasons: sharedSelectors.getAbsenceReasons(state),
    schema: serviceSelectors.getDynamicQuestionRevisionSchema(state),
  };
};

const mapDispatchToProps: PropsFromDispatch = {
  onUpdateDraft: actionCreators.UpdateDynamicQuestionDraft,
};

export default compose(
  localize(),
  connect(mapStateToProps, mapDispatchToProps),
)(Step3ReasonSpecificUsages);
